import {formatTime} from '@lsfe/tools';
/**
 * flowStatus是底层 FlowGraph组件提供的状态
 */
export const AuditStatusEnum = [
    {
        label: '已提交', value: 0, flowStatus: 'success',
    },
    {
        label: '待提交', value: 1, flowStatus: 'pending',
    },
    {
        label: '审核中', value: 10, flowStatus: 'current',
    },
    {
        label: '已通过', value: 20, flowStatus: 'success',
    },
    {
        label: '通过并加签', value: 21, flowStatus: 'success',
    },
    {
        label: '已驳回', value: 30, flowStatus: 'failure',
    },
    {
        label: '已撤销', value: 40, flowStatus: 'failure',
    },
    {
        label: '重新提交', value: 50, flowStatus: 'success',
    },
    {
        label: '已抄送', value: 60, flowStatus: 'success',
    },
    {
        label: '', value: 99, flowStatus: 'pending',
    }, // 待审核
    {
        label: '异常', value: -1, flowStatus: 'error',
    },
];

export function getStatus(status, needManualApprove) {
    // status === 99 并且 needManualApprove存在且为false 时为免审核节点
    if(status === 99 && needManualApprove === false) return {label: '免审核', value: 99, flowStatus: 'no-audit'};
    const statusObj = AuditStatusEnum.find(item => item.value === status);
    return statusObj || {};
}

function genExtraInfos(item, idx) {
    const assignessList = item.assignees.split(/,|，/).filter(assigne => !!assigne);
    return [
        assignessList.length ? {
            name: `审核人：${assignessList[0]}${assignessList.length > 1 ? '...' : ''}`,
            title: assignessList.length > 1 ? item.assignees : null,
        } : null,
        // 审批中，待审批的节点，不展示审批时间
        ![10, 99].includes(item.status) ?
            {
                name: `${idx === 0 ? '申请' : '审批'}时间：${formatTime(item.taskUtime, 'YYYY-MM-DD HH:mm')}`,
            } : null,
    ].filter(item => !!item);
}

export function defaultFormat(data, ctx) {
    const map = {};
    data.forEach((item, idx) => {
        item.$index = idx;
        map[item.taskId] = item;
    });
    return data.map((item, idx) => {
        const statusObj = getStatus(item.status, item.needManualApprove);
        return {
            name: `${item.taskName}${statusObj.label}`,
            highlight: item.status === 10 && item.taskId === ctx.taskId,
            status: statusObj.flowStatus,
            next: (item.nextTaskIdList || []).map(nodeId => ({
                index: map[nodeId].$index,
                // needManualApprove为 布尔类型并且为false的时候为false 否则为true
                weight: getStatus(map[nodeId].status, map[nodeId].needManualApprove).flowStatus, // 取下一个节点的状态作为连接线的权重
            })),
            extraInfos: genExtraInfos(item, idx),
            virtual: item.type === 5, // 虚拟网关节点
        };
    });
}
